export default __webpack_public_path__ + "static/media/news-4.93a980c6.png";